export default function getName(user) {
  return user ? user.firstName + ' ' + user.lastName : '---' ;
}